import React from "react";
import TitleValue from "../TitleValue/TitleValue";

function HealthSafetyTemplate({ hazard, peopleExposed, affected, actions }) {
  return (
    <div>
      <TitleValue title="Hazard identified" value={hazard} />
      <TitleValue title="People Exposed" value={peopleExposed} />
      <TitleValue title="How affected" value={affected} />
      <TitleValue title="Actions to control risk" value={actions} />
    </div>
  );
}

export default HealthSafetyTemplate;
